import storage from './storage';

export const funcoesTema = {
  getTema: () => {
    const tema = storage.lerStorage('tema');
    return tema ? JSON.parse(tema) : null;
  },
};

const hexToRgbNew = hex => {
  hex = hex.replace('#', '');
  var bigint = parseInt(hex, 16);
  var r = (bigint >> 16) & 255;
  var g = (bigint >> 8) & 255;
  var b = bigint & 255;

  return r + ',' + g + ',' + b;
};

export default {
  hexToRgbNew,
  funcoesTema,
};
